<script>
  import {media} from 'svelte-match-media'
  import ViewSource from '../components/ViewSource.svelte'
</script>

<div class="chart">
  <h4 class="title">Which publishers were most effective in reaching my target audience? </h4>

  {#if $media.mobile}
    <svg width="344" height="186" viewBox="0 0 344 186" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="gray-line">
        <line x1="30" y1="155.5" x2="344" y2="155.5"/>
        <line x1="30" y1="11.5" x2="344" y2="11.5"/>
        <line x1="30" y1="59.5" x2="344" y2="59.5"/>
        <line x1="30" y1="107.5" x2="344" y2="107.5"/>
      </g>
      <rect x="117" y="129" width="60" height="27" class="red"/>
      <rect x="117" y="89" width="60" height="40" class="gray"/>
      <rect x="39" y="82" width="60" height="74" class="red"/>
      <rect x="39" y="20" width="60" height="63" class="gray"/>
      <rect x="196" y="124" width="60" height="32" class="red"/>
      <rect x="196" y="83" width="60" height="41" class="gray"/>
      <rect x="273" y="141" width="60" height="15" class="red"/>
      <rect x="273" y="123" width="60" height="19" class="gray"/>
      <g class="gray">
        <text><tspan x="129.241" y="82.069">$0.39</tspan></text>
        <text><tspan x="208.601" y="76.069">$0.19</tspan></text>
        <text><tspan x="283.659" y="116.069">$0.96</tspan></text>
        <text><tspan x="49.6992" y="13.069">$0.22</tspan></text>
      </g>
      <g class="white">
        <text><tspan x="53.8018" y="58.069">49%</tspan></text>
        <text><tspan x="55.4902" y="122.069">51%</tspan></text>
        <text><tspan x="133.048" y="114.069">62%</tspan></text>
        <text><tspan x="132.993" y="146.069">38%</tspan></text>
        <text><tspan x="213.314" y="114.069">57%</tspan></text>
        <text><tspan x="212.973" y="146.069">43%</tspan></text>
        <text><tspan x="289.109" y="138.069">70%</tspan></text>
        <text><tspan x="288.747" y="154.069">30%</tspan></text>
      </g>
      <g class="gray small bold">
        <text><tspan x="0" y="14.632">12M</tspan></text>
        <text><tspan x="0" y="62.632">8M</tspan></text>
        <text><tspan x="0" y="110.632">4M</tspan></text>
        <text><tspan x="0" y="158.632">0</tspan></text>
      </g>
      <g class="white small bold">
        <text><tspan x="40" y="179.632">Network A</tspan></text>
        <text><tspan x="118" y="179.632">Network B</tspan></text>
        <text><tspan x="197" y="179.632">Network C</tspan></text>
        <text><tspan x="275" y="179.632">Network D</tspan></text>
      </g>
    </svg>
  {:else}
    <svg width="596" height="244" viewBox="0 0 596 244" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="gray-line">
        <line x1="51.9768" y1="197.9" x2="596" y2="197.9" />
        <line x1="51.9768" y1="14.7617" x2="596" y2="14.7617" />
        <line x1="51.9768" y1="75.8076" x2="596" y2="75.8076" />
        <line x1="51.9768" y1="136.854" x2="596" y2="136.854" />
      </g>
      <rect x="203" y="164.062" width="103.953" height="34.3385" class="red"/>
      <rect x="203" y="113.19" width="103.953" height="50.8718" class="gray"/>
      <rect x="68" y="104.287" width="103.953" height="94.1128" class="red"/>
      <rect x="68" y="25.436" width="103.953" height="80.1231" class="gray"/>
      <rect x="340" y="157.703" width="103.953" height="40.6974" class="red"/>
      <rect x="340" y="105.559" width="103.953" height="52.1436" class="gray"/>
      <rect x="473" y="179.323" width="103.953" height="19.0769" class="red"/>
      <rect x="473" y="156.431" width="103.953" height="24.1641" class="gray"/>
      <g class="gray">
        <text><tspan x="236" y="100.923">$0.39</tspan></text>
        <text><tspan x="375" y="93.2923">$0.19</tspan></text>
        <text><tspan x="506" y="144.164">$0.96</tspan></text>
        <text><tspan x="102" y="13.169">$0.22</tspan></text>
      </g>
      <g class="white">
        <text><tspan x="105" y="70.3997">49%</tspan></text>
        <text><tspan x="107" y="151.794">51%</tspan></text>
        <text><tspan x="241" y="141.62">62%</tspan></text>
        <text><tspan x="240" y="182.318">38%</tspan></text>
        <text><tspan x="378" y="141.62">57%</tspan></text>
        <text><tspan x="377" y="182.318">43%</tspan></text>
        <text><tspan x="511" y="172.143">70%</tspan></text>
        <text><tspan x="510" y="192.492">30%</tspan></text>
      </g>
      <g class="gray small bold">
        <text><tspan x="0" y="14.9037">12M</tspan></text>
        <text><tspan x="0" y="75.9499">8M</tspan></text>
        <text><tspan x="0" y="136.996">4M</tspan></text>
        <text><tspan x="0" y="198.042">0</tspan></text>
      </g>
      <g class="white large bold">
        <text><tspan x="81" y="221.994">Network A</tspan></text>
        <text><tspan x="217" y="221.994">Network B</tspan></text>
        <text><tspan x="353" y="221.994">Network C</tspan></text>
        <text><tspan x="486" y="221.994">Network D</tspan></text>
      </g>      
    </svg>
  {/if}
  <div class="key">
    <div class="key1 item"><div class="block"></div><p class="name">Out-of-target Reach</p></div>
    <div class="key2 item"><div class="block"></div><p class="name">In-target Reach</p></div>
    <div class="key3 item"><p class="name">Cost per in-target HH</p></div>
  </div>
  <ViewSource id="target_audience">Internal data, Aug 2020.</ViewSource>
  <p class="takeaway accent"><strong>Key takeaways:</strong></p>
  <ul>
    <li><p>Network A was best aligned with your audience, even though it cost slightly more than Network C.</p></li>
    <li><p>Network D was least aligned with your audience, so consider cutting back.</p></li>
    <li><p>Consider an audience targeted buy in the scatter market.</p></li>
  </ul>
</div>

<style>
  .title {
    margin: 0 0 40px;
  }
  @media(max-width: 375px) {
    svg {
      width: 100%;
    }
  }
  svg text {
    font-family: inherit;
    white-space: pre;
    font-size: 14px;
    font-weight: 500;
  }
  .white {
    fill: white;
  }
  .gray {
    fill: var(--gray-link);
  }
  .gray-line {
    stroke: var(--gray-line);
  }
  .bold text {
    font-weight: bold;
  }
  .small text {
    font-size: 12px;
  }
  .large text {
    font-size: 16px;
  }
  .red {
    fill: var(--verizon-red)
  }
  .key {
    display: flex;
    flex-wrap: wrap;
    font-weight: 500;
    font-size: 12px;
    margin: 10px -8px -5px -8px;
  }
  .key .name {
    margin: 0;
  }
  .key .item {
    display: flex;
    padding: 8px;
    white-space: nowrap;
  }
  .key .block {
    width: 12px;
    height: 12px;
    margin-right: 8px;
    transform: translateY(1.5px)
  }
  .key1 .block {
    background: var(--gray-link)
  }
  .key2 .block {
    background: var(--verizon-red)
  }
  @media(min-width: 768px) {
    svg {
      width: 100%;
      height: auto;
    }
    .key {
      margin-top: 24px;
    }
  }
</style>